import axiosClient from "../../config/axiosClient";

const broadcastService = {
  sendBroadcast: async (data) => {
    try {
      const response = await axiosClient.post("/broadcast/send", data);
      return response.data;
    } catch (error) {
      console.error("Lỗi gửi broadcast:", error);
      throw error;
    }
  },

  getBroadcasts: async () => {
    try {
      const response = await axiosClient.get("/broadcast/logs");
      return response.data;
    } catch (error) {
      console.error("Lỗi lấy broadcast:", error);
      return [];
    }
  },

  getDepartments: async () => {
    try {
      const response = await axiosClient.get("/broadcast/departments");
      return response.data;
    } catch (error) {
      console.error("Lỗi lấy danh sách phòng ban:", error);
      return [];
    }
  }
};

export default broadcastService;
